interface SoldOutBannerProps {
  visible: boolean;
}

export function SoldOutBanner({ visible }: SoldOutBannerProps) {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-10 grid place-items-center px-[16px] [container-type:size]"
      role="status"
      lang="en"
    >
      {visible && (
        <div className="max-w-full rounded-control border border-border-strong bg-surface-card px-4 py-2.5 text-center text-text-primary shadow-lg sm:px-5 sm:py-3">
          <p className="font-sold-out text-[length:clamp(21.6px,min(8.1cqw,18cqh),48.6px)] leading-none font-[230] tracking-[-0.5px] whitespace-nowrap [font-optical-sizing:none] sm:tracking-[-1px]">
            SOLD OUT
          </p>
        </div>
      )}
    </div>
  );
}
